import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DropDownComponent implements OnChanges {
  @Input() label: string = '';
  @Input() options: any[] = [];
  @Input() labelKey: string = 'type';
  @Input() selected: any = null;
  @Input() table: boolean = false;
  @Input() icon?: string;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<any>();

  filteredOptions: any[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options'] && this.options) {
      this.filteredOptions = this.removeDuplicates(this.options, this.labelKey);
    }
  }

  removeDuplicates(arr: any[], key: string): any[] {
    const seen = new Set();
    return arr.filter(item => {
      const value = item[key];
      if (seen.has(value)) {
        return false;
      }
      seen.add(value);
      return true;
    });
  }

  onSelectChange(event: any) {
    const selectedObj = event.detail.value;
    this.valueChange.emit(selectedObj);
  }

  compareWith = (o1: any, o2: any) => {
    return o1 && o2 ? o1.value === o2.value : o1 === o2;
  };
}